/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../summaryStyle";
import GridEditRow from "../../Common/GridEditRow/GridEditRow";
import Typography from "@mui/material/Typography";
import {Box} from "@mui/material";

type IncomeSummaryProps = {
  formData: Record<string, any>;
  basePath: string;
};

const IncomeSummary = ({ formData, basePath }: IncomeSummaryProps) => {
  return (
    <>
      <Grid item xs={12} sx={summaryStyle.subHeadline}>
        <Typography variant={"h5"}>Einnahmen</Typography>
      </Grid>
      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={"hasSocialWelfare"} sx={summaryStyle.scrollToAnchor} />
        Sozialhilfe
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: basePath + "sozialhilfe",
        }}
      >
        {formData.hasSocialWelfare === "yes" ? "Es wird Sozialhilfe bezogen" : "Es wird keine Sozialhilfe bezogen"}
      </GridEditRow>
      <>
        <Grid item xs={12} sx={summaryStyle.question}>
          Einkommensarten
        </Grid>

        <Box id={"hasIncomeEmployment"} sx={summaryStyle.scrollToAnchor} />
        <GridEditRow
          item
          xs={12}
          to={{
            pathname: basePath + "arbeitnehmer",
            state: {
              field: "hasIncomeEmployment",
            },
          }}
        >
          {formData.hasIncomeEmployment === "yes" ? "Arbeitnehmerlohn: " + formData.incomeEmploymentAmount + " €" : "Kein Arbeitnehmerlohn"}
        </GridEditRow>

        <Box id={"hasIncomeSelfEmployment"} sx={summaryStyle.scrollToAnchor} />
        <GridEditRow
          item
          xs={12}
          sx={summaryStyle.addMargin}
          to={{
            pathname: basePath + "selbststaendig",
            state: {
              field: "hasIncomeSelfEmployment",
            },
          }}
        >
          {formData.hasIncomeSelfEmployment === "yes"
            ? "Selbstständigkeit: " + formData.incomeSelfEmploymentAmount + " €"
            : "Kein Einkommen als Selbstständiger"}
        </GridEditRow>

        <Box id={"hasIncomeRent"} sx={summaryStyle.scrollToAnchor} />
        <GridEditRow
          item
          xs={12}
          sx={summaryStyle.addMargin}
          to={{
            pathname: basePath + "vermietung",
            state: {
              field: "hasIncomeRent",
            },
          }}
        >
          {formData.hasIncomeRent === "yes" ? "Mieteinnahmen: " + formData.incomeRentAmount + " €" : "Keine Mieteinnahmen"}
        </GridEditRow>

        <Box id={"hasIncomeAssets"} sx={summaryStyle.scrollToAnchor} />
        <GridEditRow
          item
          xs={12}
          sx={summaryStyle.addMargin}
          to={{
            pathname: basePath + "kapitalvermoegen",
            state: {
              field: "hasIncomeAssets",
            },
          }}
        >
          {formData.hasIncomeAssets === "yes" ? "Kapitalvermögenserträge: " + formData.incomeAssetsAmount + " €" : "Keine Kapitalvermögenserträge"}
        </GridEditRow>

        <Box id={"hasIncomeChildAllowance"} sx={summaryStyle.scrollToAnchor} />
        <GridEditRow
          item
          xs={12}
          sx={summaryStyle.addMargin}
          to={{
            pathname: basePath + "kindergeld",
            state: {
              field: "hasIncomeChildAllowance",
            },
          }}
        >
          {formData.hasIncomeChildAllowance === "yes" ? "Kindergeld/-zuschlag: " + formData.incomeChildAllowanceAmount + " €" : "Kindergeld/-zuschlag"}
        </GridEditRow>

        <Box id={"hasIncomeLiving"} sx={summaryStyle.scrollToAnchor} />
        <GridEditRow
          item
          xs={12}
          sx={summaryStyle.addMargin}
          to={{
            pathname: basePath + "wohngeld",
          }}
        >
          {formData.hasIncomeLiving === "yes" ? "Wohngeld: " + formData.incomeLivingAmount + " €" : "Kein Wohngeld"}
        </GridEditRow>

        <Box id={"hasIncomeAlimony"} sx={summaryStyle.scrollToAnchor} />
        <GridEditRow
          item
          xs={12}
          sx={summaryStyle.addMargin}
          to={{
            pathname: basePath + "unterhalt",
            state: {
              field: "hasIncomeAlimony",
            },
          }}
        >
          {formData.hasIncomeAlimony === "yes" ? "Unterhalt: " + formData.incomeAlimonyAmount + " €" : "Keinen Unterhalt"}
        </GridEditRow>

        <Box id={"hasIncomePension"} sx={summaryStyle.scrollToAnchor} />
        <GridEditRow
          item
          xs={12}
          sx={summaryStyle.addMargin}
          to={{
            pathname: basePath + "rente",
            state: {
              field: "hasIncomePension",
            },
          }}
        >
          {formData.hasIncomePension === "yes" ? "Rente/Pension: " + formData.incomePensionAmount + " €" : "Keine Rente/Pension"}
        </GridEditRow>

        <Box id={"hasIncomeUnemploymentAllowance"} sx={summaryStyle.scrollToAnchor} />
        <GridEditRow
          item
          xs={12}
          sx={summaryStyle.addMargin}
          to={{
            pathname: basePath + "alg1",
          }}
        >
          {formData.hasIncomeUnemploymentAllowance === "yes"
            ? "Arbeitslosengeld I: " + formData.incomeUnemploymentAllowanceAmount + " €"
            : "Kein Arbeitslosengeld I"}
        </GridEditRow>

        <Box id={"hasIncomeUnemploymentAllowance2"} sx={summaryStyle.scrollToAnchor} />
        <GridEditRow
          item
          xs={12}
          sx={summaryStyle.addMargin}
          to={{
            pathname: basePath + "alg2",
            state: {
              field: "hasIncomeUnemploymentAllowance2",
            },
          }}
        >
          {formData.hasIncomeUnemploymentAllowance2 === "yes"
            ? "Arbeitslosengeld II: " + formData.incomeUnemploymentAllowance2Amount + " €"
            : "Kein Arbeitslosengeld II"}
        </GridEditRow>

        <Box id={"hasIncomeSickness"} sx={summaryStyle.scrollToAnchor} />
        <GridEditRow
          item
          xs={12}
          sx={summaryStyle.addMargin}
          to={{
            pathname: basePath + "krankengeld",
            state: {
              field: "hasIncomeSickness",
            },
          }}
        >
          {formData.hasIncomeSickness === "yes" ? "Krankengeld: " + formData.incomeSicknessAmount + " €" : "Kein Krankengeld"}
        </GridEditRow>

        <Box id={"hasIncomeParentalAllowance"} sx={summaryStyle.scrollToAnchor} />
        <GridEditRow
          item
          xs={12}
          sx={summaryStyle.addMargin}
          to={{
            pathname: basePath + "elterngeld",
            state: {
              field: "hasIncomeParentalAllowance",
            },
          }}
        >
          {formData.hasIncomeParentalAllowance === "yes" ? "Elterngeld: " + formData.incomeParentalAllowanceAmount + " €" : "Kein Elterngeld"}
        </GridEditRow>

        <Grid item xs={12} sx={summaryStyle.question}>
          <Box id={"hasIncomeOther1"} sx={summaryStyle.scrollToAnchor} />
          Sonstiges Einkommen
        </Grid>
        <GridEditRow
          item
          xs={12}
          to={{
            pathname: basePath + "sonstige-einnahmen",
            state: {
              field: "hasIncomeOther1",
            },
          }}
        >
          {formData.hasIncomeOther1 === "yes" ? (
            <>
              <br />
              Beschreibung: {formData.incomeOther1Name} mit einem Bruttobetrag von {formData.incomeOther1Amount} € ({formData.incomeOther1Period})
            </>
          ) : (
            "Kein sonstiges Einkommen"
          )}
          {formData.hasIncomeOther2 === "yes" && (
            <>
              <br />
              <br />
              Beschreibung: {formData.incomeOther2Name} mit einem Bruttobetrag von {formData.incomeOther2Amount} € ({formData.incomeOther2Period})
            </>
          )}
        </GridEditRow>

        {formData.incomeDescription && (
          <>
            <Box id={"incomeDescription"} sx={summaryStyle.scrollToAnchor} />
            <GridEditRow
              item
              xs={12}
              to={{
                pathname: basePath + "sonstiger-unterhalt",
                state: {
                  field: "hasIncomeOther1",
                },
              }}
            >
              Beschreibung: {formData.incomeDescription}
            </GridEditRow>
          </>
        )}
      </>
    </>
  );
};

export default IncomeSummary;
